import "./polyfills";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { AppProviders } from "@/app/AppProviders";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");
const root = ReactDOM.createRoot(rootElement);

root.render(
  <AppProviders>
    <App />
  </AppProviders>
);

// Register service worker
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((_registration) => {
        // console.log('ServiceWorker registration successful:', registration.scope);
      })
      .catch((_error) => {
        // console.log('ServiceWorker registration failed:', error);
      });
  });
}
